import { atom } from "recoil";

export const changeNoteState = atom<string>({
  key: "changeNoteState",
  default: "",
});
